import { SimplePopup } from './SimplePopup';

/**
 * Listens for the video popup events emitted by VideoPopup and shows the "Did you enjoy the
 * webinar?" rating popup once the user starts (or finishes) watching.
 */
export class RatingActivator {
    constructor() {
        document.addEventListener('vet-agenda-actions:video-opened', (event) => {
            const webinarUid = event.detail && event.detail.webinarUid;
            if (!webinarUid) {
                return;
            }
            if (this.isRatingEnabled(webinarUid) && !this.isWebinarRated(webinarUid)) {
                this.showPopup(webinarUid);
            }
        });

        document.addEventListener('vet-agenda-actions:video-threshold-reached', (event) => {
            const webinarUid = event.detail && event.detail.webinarUid;
            if (!webinarUid) {
                return;
            }
            this.enableRating(webinarUid);
            this.showPopup(webinarUid);
        });
    }

    findRatingWrapper(webinarUid) {
        const element = document.querySelector('[data-rating][data-webinar="' + webinarUid + '"]');
        if (!element) {
            return null;
        }
        return element.closest('.c-ratings__wrapper');
    }

    isWebinarRated(webinarUid) {
        const wrapper = this.findRatingWrapper(webinarUid);
        if (!wrapper) {
            return false;
        }
        const ownRating = wrapper.querySelector('.c-ratings__own .fa-star');
        return ownRating !== null;
    }

    isRatingEnabled(webinarUid) {
        const wrapper = this.findRatingWrapper(webinarUid);
        if (!wrapper) {
            return false;
        }
        const right = wrapper.querySelector('.c-ratings__right');
        return right !== null && !right.classList.contains('invisible');
    }

    enableRating(webinarUid) {
        const wrapper = this.findRatingWrapper(webinarUid);
        if (!wrapper) {
            return;
        }
        const right = wrapper.querySelector('.c-ratings__right');
        if (right) {
            right.classList.remove('invisible');
        }
    }

    showPopup(webinarUid) {
        const $element = jQuery('[data-rating][data-webinar="' + webinarUid + '"]');
        if ($element.length === 0) {
            return;
        }
        const $ratingsRight = $element.parents('.c-ratings__wrapper').find('.c-ratings__right');
        if ($ratingsRight.length === 0) {
            return;
        }
        const popup = new SimplePopup($ratingsRight, { content: 'Did you enjoy the webinar?' });
        popup.show();
    }
}
